export default __webpack_public_path__ + "53600e2cbbd5d6b1dcb9fad1905b7c4f.ttf";